import React from 'react';
import { ACCOUNT_STATUS_LABELS, ACCOUNT_STATUS_TONE } from '@/lib/constants';

const TONE_MAP = {
  green: 'bg-[var(--ns-green)]/12 text-[var(--ns-green-700)] border-[var(--ns-green)]/40',
  amber: 'bg-[var(--ns-amber-100)] text-[var(--ns-gold-700)] border-[var(--ns-gold)]/40',
  red: 'bg-[var(--ns-red)]/12 text-[var(--ns-red)] border-[var(--ns-red)]/40',
  gray: 'bg-[var(--ns-bg-2)] text-[var(--ns-text-muted)] border-[var(--ns-border)]',
};

export const StatusBadge = ({ status, className = '' }) => {
  const label = ACCOUNT_STATUS_LABELS[status] || status || '—';
  const tone = ACCOUNT_STATUS_TONE[status] || 'gray';
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-semibold uppercase tracking-wider ${TONE_MAP[tone]} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {label}
    </span>
  );
};
